/** Returns true if the value looks like a JWT (three non-empty base64url segments). */
export function isJwtFormat(token) {
  if (typeof token !== "string") return false
  const parts = token.split(".")
  return parts.length === 3 && parts.every(part => part.length > 0)
}

/** Parsed user from localStorage, or null if missing required fields or token. */
export function getStoredUser() {
  const userStr = localStorage.getItem("user")
  if (!userStr) return null

  try {
    const user = JSON.parse(userStr)
    const { id, email, companyId, token } = user
    if (id == null || !email || companyId == null || !isJwtFormat(token)) {
      return null
    }
    return user
  } catch {
    return null
  }
}

export function clearStoredSession() {
  localStorage.removeItem("user")
  localStorage.removeItem("profilePic")
}
